import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import * as AuthApi from "api/common/Auth.api";

import VerifyCastingEmailComponent from "./VerifyCastingEmail.component";

const UpdateEmailContainer = (props: any) => {
  const location = useLocation();

  const [isVerify, setIsVerify] = useState(null);

  const VerifyCastingEmail = async () => {
    const code = location.pathname.split("/").pop();
    const result: any = await AuthApi.verifyEmail(code);

    setIsVerify(result);
  };

  useEffect(() => {
    VerifyCastingEmail();
  }, []);

  return <VerifyCastingEmailComponent isVerify={isVerify} />;
};

export default UpdateEmailContainer;
